import { render, staticRenderFns } from "./MergeWorksDialog.vue?vue&type=template&id=a1162604&scoped=true"
import script from "./MergeWorksDialog.vue?vue&type=script&lang=js"
export * from "./MergeWorksDialog.vue?vue&type=script&lang=js"
import style0 from "./MergeWorksDialog.vue?vue&type=style&index=0&id=a1162604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1162604",
  null
  
)

export default component.exports